import { styled as r } from "styled-components";
import { LikeButton as t } from "../LikeButton/index.js";
import { ActionsButton as i } from "../../style.js";
import { BodyHeavy as n } from "../../../../styles/typography/index.js";
import { Theme as o } from "../../../../styles/themes/index.js";
const m = r(i)`
  i {
    display: inline;
    font-size: 18px;
    margin-right: 6px;
    color: rgb(${o.colors.Brand});
  }
  &[aria-hidden='true'] {
    display: none;
  }

  color: rgb(${o.colors.Alpha});
  &:hover {
    color: rgb(${o.colors.Brand});
  }

  ${n}
`, c = r(t)`
  display: inline-flex;
`, d = r.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;
export {
  d as ButtonsContainer,
  c as LikeButtonOnActions,
  m as ReplyButton
};
